/*
 * Copyright © 2018, Rezo Zero
 *
 * @file BubbleSketch.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 */

import BubbleScene from '../scenes/BubbleScene'

const bubbleSketch = p5 => {
    const scene = new BubbleScene(p5)

    p5.preload = () => {
        scene.preload(p5)
    }

    p5.setup = () => {
        scene.setup(p5)
    }

    p5.draw = () => {
        scene.draw(p5)
    }
}

export default bubbleSketch



// WEBPACK FOOTER //
// ./webpack/js/sketchs/BubbleSketch.js